import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateAgo'
})
export class DateAgoPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  translateDate(i) {
    if(i == 'year') {
      return this.translate.instant('dateAgoPipe.year');
    } else if(i == 'month') {
      return this.translate.instant('dateAgoPipe.month');
    }
    else if(i == 'week') {
      return this.translate.instant('dateAgoPipe.week');
    }
    else if(i == 'day') {
      return this.translate.instant('dateAgoPipe.day');
    }
    else if(i == 'hour') {
      return this.translate.instant('dateAgoPipe.hour');
    }
    else if(i == 'minute') {
      return this.translate.instant('dateAgoPipe.minute');
    }
    else if(i == 'second') {
      return this.translate.instant('dateAgoPipe.second');
    }
  }

  transform(value: any, args?: any): any {

    if (value) {

      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);

      if (seconds < 29) // less than 30 seconds ago will show as 'Just now'

        return this.translate.instant('dateAgoPipe.justNow');

      const intervals = {

        'year': 31536000,

        'month': 2592000,

        'week': 604800,

        'day': 86400,

        'hour': 3600,

        'minute': 60,

        'second': 1

      };

      let counter;

      for (const i in intervals) {

        counter = Math.floor(seconds / intervals[i]);

        if (counter > 0)

          if (counter === 1) {
            
            return `${counter} ${this.translateDate(i)} ${this.translate.instant('dateAgoPipe.singular')}`; // singular (1 day ago)

          } else {
            const langCode = localStorage.getItem('language');
            if(i === 'day' && langCode === 'pt-PT') {
              return counter + ' ' + this.translateDate(i) + ' ' + this.translate.instant('dateAgoPipe.singular'); // singular (1 day ago)
            } else {
              return counter + ' ' + this.translateDate(i) + this.translate.instant('dateAgoPipe.plural'); // plural (2 days ago)
            }

          }

      }

    }

    return value;

  }

}
